import { Card, CardContent, CardTitle } from "@/components/ui/card";
import { ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { ChartContainer, type ChartConfig } from "@/components/ui/chart";
import axiosInstance from "@/utils/axiosInstance";
import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";

const chartConfig = {
  revenue: {
    label: "Revenue",
    color: "var(--text-foreground)",
  },
} satisfies ChartConfig;

const Revenue = ({ range }: { range: { startDate: Date; endDate: Date } }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const unsub = async () => {
      const { data } = await axiosInstance.get("/reports/monthly-revenue", {
        params: {
          startDate: range.startDate.toISOString().split("T")[0],
          endDate: range.endDate.toISOString().split("T")[0],
        },
      });

      setChartData(data);
    };

    unsub();
  }, [range]);

  return (
    <Card className="max-w-full">
      <CardContent>
        <CardTitle>Total revenue</CardTitle>

        <ChartContainer config={chartConfig} className="min-h-[200px] w-full">
          <BarChart
            accessibilityLayer
            data={chartData}
            margin={{ top: 20, left: -20, bottom: -10 }}
          >
            <ChartTooltip content={<ChartTooltipContent />} />
            <CartesianGrid
              strokeDasharray="3 3"
              vertical={false}
              stroke="#e5e7eb"
            />

            <XAxis
              dataKey="month"
              orientation="bottom"
              tick={{ fontSize: 12 }}
              axisLine={false}
              tickLine={false}
            />

            <YAxis
              dataKey="revenue"
              tick={{ fontSize: 12 }}
              axisLine={false}
              tickLine={false}
            />
            <Bar dataKey="revenue" fill="var(--color-revenue)" radius={4} />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};

export default Revenue;
